import { createApiSlice } from "@common";
import {
    MY_INFO_AWARDS_DETAILS
} from "@routes";

// Define the API config array
const apiConfig = [
    {
        name: "addEmployeeAwards",
        method: "post",
        url: MY_INFO_AWARDS_DETAILS,
        stateKey: "message",
    },
    {
        name: "getEmployeeAwards",
        method: "get",
        url: MY_INFO_AWARDS_DETAILS,
        stateKey: "data",
    },
    {
        name: "updateEmployeeAwards",
        method: "put",
        url: MY_INFO_AWARDS_DETAILS,
        stateKey: "message",
    },
    {
        name: "deleteEmployeeAwards",
        method: "delete",
        url: MY_INFO_AWARDS_DETAILS,
        stateKey: "message",
    },
];

// Define custom reducers and their initial state
const customReducers = {
    initialState: {
        data: [],
        additionalData: [],
    },
    reducers: {
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
    },
    extraReducers: {
        // Example of custom extra reducer
        someCustomAction: (state, action) => {
            // Custom reducer logic
        },
    },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
    "EmployeeAwards",
    apiConfig,
    customReducers,
);
const EmployeeAwardsSlice = slice;
// Export the slice's reducer
export default EmployeeAwardsSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
    addEmployeeAwards,
    getEmployeeAwards,
    updateEmployeeAwards,
    deleteEmployeeAwards
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
    actions;
